import React from 'react';

// NOTE: v1 placeholder artwork. Designer pass pending.
export default function ValentinesAccessory() {
  return (
    <g aria-hidden="true">
      {/* Big heart on roof */}
      <path d="M100,72 C92,56 70,56 70,76 C70,98 100,118 100,118 C100,118 130,98 130,76 C130,56 108,56 100,72 Z" fill="#E0290A" />
      <circle cx="85" cy="72" r="2.5" fill="#F9FCF1" opacity="0.4" />
      {/* Small floating hearts around */}
      <path d="M40,60 C38,56 32,56 32,60 C32,66 40,72 40,72 C40,72 48,66 48,60 C48,56 42,56 40,60 Z" fill="#E0290A" opacity="0.6" />
      <path d="M165,75 C163,72 158,72 158,75 C158,79 165,84 165,84 C165,84 172,79 172,75 C172,72 167,72 165,75 Z" fill="#E0290A" opacity="0.6" />
      <path d="M155,40 C154,38 150,38 150,40 C150,43 155,46 155,46 C155,46 160,43 160,40 C160,38 156,38 155,40 Z" fill="#E0290A" opacity="0.4" />
    </g>
  );
}
